


export function getRandomColor(): string {
	// Generate a random color in hexadecimal format
	return '#' + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0');
}

/**
 * Raggruppa i dati in base alla chiave
 */
export function grupBy(data: any[], key: string): { [key: string]: any[] } {
	return data.reduce((acc, item) => {
		const group = item[key]
		if (!acc[group]) {
			acc[group] = []
		}
		acc[group].push(item)
		return acc
	}, {})
}

/**
 * dato un array di dati (normalizzati) 
 * aggiunge le proprietà day, month, year
 * presa da una delle proprietà dei dati
 */
export function explodeDate(data: any[], propName = 'date') {
	data.forEach(item => {
		const [year, month, day] = item[propName]?.split('-') ?? []
		item[`${propName}_day`] = parseInt(day)
		item[`${propName}_month`] = parseInt(month)
		item[`${propName}_year`] = parseInt(year)
	})
}

/**
 * semplice utility che traduce il numero del mese in nome del mese
 */
export function getMonthName(monthNum: string): string {
	const index = parseInt(monthNum)
	return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][index - 1]
}
